import React from 'react';
import clsx from 'clsx';
import styles from './FinalSaleBadge.module.scss';

export const FinalSaleBadge = ({ message = 'Final Sale', className, barrierPosition }) => (
  <div className={clsx(styles.root, className?.root)}>
    {barrierPosition && barrierPosition === 'left' && (
      <div className={clsx(styles.barrierRoot, className?.barrier, styles.barrier_left)} />
    )}
    <span className={clsx(styles.message, className?.message)}>{message}</span>
    {barrierPosition && barrierPosition === 'right' && (
      <div className={clsx(styles.barrierRoot, className?.barrier, styles.barrier_right)} />
    )}
  </div>
);
